import { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import RegisterParents from '../../components/RegisterParents';
import RegisterChild from '../../components/RegisterChild';
import RegisterDeclaration from '../../components/RegisterDeclaration';
import RegisterContinue from '../../components/organisms/RegisterContinue';
import { useMutation } from 'react-query';

const Register = () => {
  const navigate = useNavigate();
  const [msg, setMsg] = useState('');
  const [submissionComplete, setSubmissionComplete] = useState(false);
  const [registeredStudents, setRegisteredStudents] = useState([]);
  const param = useParams();
  const [openDialog, setOpenDialog] = useState(false);

  const newFormState = {
    newRegistration: 1, // to be made redundant
    registrationState: 1, // to be used to determine registration mode (1: new / 2: continue)
    parents: {
      primary_parent_id: '',
      primary_parent_name: '',
      primary_parent_relationship: '',
      primary_parent_identity_number: '',
      primary_parent_mobile: '',
      primary_parent_email: '',
      primary_parent_religion: '',
      sec_parent_id: '',
      sec_parent_name: '',
      sec_parent_relationship: '',
      sec_parent_identity_number: '',
      sec_parent_mobile: '',
      sec_parent_email: '',
      sec_parent_religion: '',
    },
    students: [],
  };

  const [formData, setFormData] = useState(newFormState);

  // For continuing registration, called by /register/continue
  const continueRegistration = data => {
    setRegisteredStudents(data.students);
    setFormData(prev => {
      return {
        ...prev,
        ['registrationState']: 2,
        parents: {
          ...prev.parents,
          ['primary_parent_id']: data.parent_id,
          ['sec_parent_id']: data.secParent_id,
        },
      };
    });
    navigate('/register/child');
  };

  // UPDATE formData (parent / child)
  const updateFormData = ({ name, value }, childObj, type) => {
    if (type === 'parents') {
      setFormData(prev => {
        return { ...prev, parents: { ...prev.parents, [name]: value } };
      });
    } else {
      if (childObj !== undefined) {
        setFormData(prev => {
          return { ...prev, students: [...prev.students, childObj] };
        });
      }
    }
  };

  // check Parent duplicate ID
  const checkDuplicateID = async () => {
    if (formData.parents.primary_parent_identity_number) {
      const checkID = new FormData();
      checkID.append('mode', 'checkID');
      checkID.append(
        'idvalue',
        formData.parents.primary_parent_identity_number
      );
      const output = await axios.post(config.PARENTS_API, checkID);
      return output.data.response.status;
    }
  };

  // Form Submission
  const mutation = useMutation(['submitFormData'], async () => {
    setMsg('');
    const output = await axios.post(config.API, formData);
    if (output.data.response.status === 'OK') {
      setSubmissionComplete(true);
    } else {
      setMsg(
        'Sorry, something went wrong and your information cannot be saved.'
      );
    }
  });
  const submitFormData = async e => {
    mutation.mutate();
  };

  // Form render logic
  let formToRender;
  if (param.page === undefined) {
    formToRender = (
      <RegisterParents
        formData={formData}
        updateFormData={updateFormData}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        checkDuplicateID={checkDuplicateID}
      />
    );
  } else if (param.page === 'child') {
    if (
      formData.parents.primary_parent_name === '' &&
      formData.parents.primary_parent_id === ''
    ) {
      window.location.replace('/register');
    }
    formToRender = (
      <RegisterChild
        formData={formData}
        updateFormData={updateFormData}
        registeredStudents={registeredStudents}
      />
    );
  } else if (param.page === 'continue') {
    formToRender = (
      <RegisterContinue searchResultSetter={continueRegistration} />
    );
  } else if (param.page === 'declaration') {
    if (
      formData.parents.primary_parent_name === '' &&
      formData.parents.primary_parent_id === ''
    )
      window.location.replace('/register');

    formToRender = (
      <RegisterDeclaration
        submitFormData={submitFormData}
        statusMsg={msg}
        setStatusMsg={setMsg}
        submissionComplete={submissionComplete}
        loading={mutation.isLoading}
      />
    );
  } else {
    formToRender = <h1>Invalid Page</h1>;
  }

  return (
    <div>
      {formToRender}

      {submissionComplete && (
        <div className='center '>
          <div className='successMsg pageSubHeader' data-cy='success-message'>
            Thank you! Your registration has been submitted.
          </div>
          <div className='spacer'></div>
          <div className='pHeader'>
            <Link to='/register/upload'>Proceed to upload documents</Link>
          </div>
        </div>
      )}

      <div className='spacer'></div>
    </div>
  );
};

export default Register;
